import ALEPH_ONE__ABSTRACTIONS from './songs/ALEPH_ONE__ABSTRACTIONS.mp3';
import BRENDON_MOELLER__SOLAR_SHADE from './songs/BRENDON_MOELLER__SOLAR_SHADE.mp3';
import BRENDON_MOELLER__CELESTIAL_HARMONICS from './songs/BRENDON_MOELLER__CELESTIAL_HARMONICS.mp3';
import HANK_LOTION__I_SEE_YOU_DANCIN from './songs/HANK_LOTION__I_SEE_YOU_DANCIN.mp3';
import VALANTE__WOMBAT from './songs/VALANTE__WOMBAT.mp3';

export default [
  {
    title: 'ABSTRACTIONS', artist: 'ALEPH ONE', color: 0x004444, source: ALEPH_ONE__ABSTRACTIONS,
  },
  {
    title: 'CELESTIAL HARMONICS', artist: 'BRENDON MOELLER', color: 0x0500ff, source: BRENDON_MOELLER__CELESTIAL_HARMONICS,
  },
  {
    title: 'WOMBAT', artist: 'VALANTE', color: 0xffffff, source: VALANTE__WOMBAT,
  },
  {
    title: 'SOLAR SHADE', artist: 'BRENDON MOELLER', color: 0x00ff00, source: BRENDON_MOELLER__SOLAR_SHADE,
  },
  {
    title: 'I SEE YOU DANCIN', artist: 'HANK LOTION', color: 0xffff00, source: HANK_LOTION__I_SEE_YOU_DANCIN,
  },
];
